import { HotelReservation } from "@/types/hotelReservation";
import { getGlobalSessionId, ecsClient } from "@/services";

type GetUserReservationsResponse = {
  success: boolean;
  message: string;
  reservations: HotelReservation[];
  totalCount: number;
};

type HotelReservationAnalysisResponse = {
  success: boolean;
  message: string;
  analysis: any;
};

type DeleteHotelReservationResponse = {
  success: boolean;
  message: string;
  reservation: HotelReservation;
};

type HotelPricesRequest = {
  hotelId: string;
  checkInDate: string;
  checkOutDate: string;
  noOfRooms?: number;
  noOfAdults?: number;
};

type HotelPricesResponse = {
  hotelId: string;
  checkInDate: string;
  checkOutDate: string;
  noOfRooms: number;
  noOfAdults: number;
  prices: {
    vendor: string;
    price: number;
    tax: number;
  }[];
};

const HotelReservationServices = {
  getReservations: async () => {
    const sessionId = getGlobalSessionId();

    const result = await ecsClient.get<GetUserReservationsResponse>(
      "/reservations",
      {
        params: { sessionId },
      }
    );

    return result.data?.reservations || [];
  },

  analyzeUserEmailForHotelReservations: async (userId: string) => {
    const result = await ecsClient.post<HotelReservationAnalysisResponse>(
      "/reservations/analyze",
      {
        userId,
      }
    );

    return result.data;
  },

  deleteHotelReservation: async (confirmationNumber: string) => {
    const sessionId = getGlobalSessionId();

    const result = await ecsClient.delete<DeleteHotelReservationResponse>(
      "/reservations",
      {
        data: {
          sessionId: sessionId!,
          confirmationNumber: confirmationNumber,
        },
      }
    );

    return result.data;
  },

  getHotelPrices: async (params: HotelPricesRequest) => {
    const queryParams = {
      checkInDate: params.checkInDate,
      checkOutDate: params.checkOutDate,
      noOfRooms: params.noOfRooms || 1,
      noOfAdults: params.noOfAdults || 2,
    };

    const result = await ecsClient.get<HotelPricesResponse>(
      `/hotel-price/${params.hotelId}`,
      { params: queryParams }
    );

    return result.data;
  },
};

export default HotelReservationServices;
